import { useState } from 'react'

interface ToastOptions {
    title: string
    description?: string
    variant?: 'default' | 'destructive' | 'success'
}

export function useToast() {
    const [toasts, setToasts] = useState<ToastOptions[]>([])

    const toast = (options: ToastOptions) => {
        setToasts((current) => [...current, options])
        // Remove toast after 5 seconds
        setTimeout(() => {
            setToasts((current) => current.filter((t) => t !== options))
        }, 5000)
    }

    return { toast, toasts }
} 